// components/FAQ/FAQ.tsx
import React, { FC, useState } from "react";
import Modal from "shared/ui/Modal";

// FAQ Data from document
export type FAQItem = {
  id: number,
  question: string,
  answer: string;
};

interface FAQProps {
  className?: string;
  initialDisplayCount?: number;
  title?: string;
  showViewAll?: boolean;
  faqData: FAQItem[]
}

const FAQ: FC<FAQProps> = ({
                             className = "",
                             initialDisplayCount = 4,
                             title = "FAQ",
                             showViewAll = true,
                             faqData
                           }) => {
  const [showModalFAQ, setShowModalFAQ] = useState<boolean>(false);
  const [selectedFAQ, setSelectedFAQ] = useState<FAQItem | null>(null);
  const [showAllFAQ, setShowAllFAQ] = useState<boolean>(false);

  const handleOpenFAQ = (faq: FAQItem) => {
    setSelectedFAQ(faq);
    setShowModalFAQ(true);
  };

  // Afficher les premières questions ou toutes selon l'état
  const displayedFAQs = showAllFAQ ? faqData : faqData.slice(0, initialDisplayCount);

  return (
    <>
      <div className={`card d-flex flex-column h-100 ${className}`}>
        <div className="text-secondary">
          <div className="d-flex flex-column gap-3">
            <div className="text-primary text-mm bold">
              {title}
            </div>
            <div className="text-sm text-muted-foreground d-flex flex-column justify-content-start align-items-start gap-05">
              {displayedFAQs.map((faq) => (
                <div
                  key={faq.id}
                  className="faq-question pointer hover:shadow"
                  onClick={() => handleOpenFAQ(faq)}
                >
                  {faq.question}
                </div>
              ))}

              {showViewAll && !showAllFAQ && faqData.length > initialDisplayCount && (
                <div
                  className="faq-view-all text-primary pointer fw-bold mt-2"
                  onClick={() => setShowAllFAQ(true)}
                >
                  Voir toutes les questions ({faqData.length - initialDisplayCount} supplémentaires)
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {showModalFAQ && selectedFAQ && (
        <Modal
          subtitle={selectedFAQ.question}
          onClose={() => setShowModalFAQ(false)}
          isOpen={showModalFAQ}
          title="FAQ"
          infoModal={true}
          type="info"
        >
          <div className="faq-modal-content">
            {selectedFAQ.answer}
          </div>
        </Modal>
      )}
    </>
  );
};

export default FAQ;